import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Navbar from "./components/Navbar";
import AylikIsg from "./pages/AylikIsg.js";
import PatronRutin from "./pages/PatronRutin.js";
import FirestoreSqlConsole from "./pages/FirestoreSqlConsole.js";
import HakedisTanimlari from "./pages/HakedisTanimlari";
import HakedisHesaplama from "./pages/HakedisHesaplama";

import { db } from "../../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

export default function Main() {
  const { user, role, userPermissions, loading } = useAuth();
  const [kisiMapFallback, setKisiMapFallback] = useState(null);
  const [fetchingPerm, setFetchingPerm] = useState(false);

  const mapInCtx = userPermissions?.["kisiye-ozel-rapor"];

  useEffect(() => {
    if (loading || !user) return;

    const hasAnyTrue = (map) =>
      map && typeof map === "object" && Object.values(map).some((v) => v === true);

    if (hasAnyTrue(mapInCtx)) {
      setKisiMapFallback(null);
      return;
    }

    (async () => {
      try {
        setFetchingPerm(true);
        let snap = null;
        if (user.email) snap = await getDoc(doc(db, "users", user.email));
        if (!snap || !snap.exists()) snap = await getDoc(doc(db, "users", user.uid));
        const data = snap?.exists() ? (snap.data() || {}) : {};
        setKisiMapFallback(data["kisiye-ozel-rapor"] || {});
      } finally {
        setFetchingPerm(false);
      }
    })();
  }, [loading, user, mapInCtx]);

  if (loading || fetchingPerm) {
    return <div className="text-center mt-10">Yükleniyor...</div>;
  }
  if (!user || !role) {
    return <div className="text-center mt-10">Yetki bulunamadı.</div>;
  }

  const hasAnyTrue = (map) =>
    map && typeof map === "object" && Object.values(map).some((v) => v === true);

  const effectiveMap = hasAnyTrue(mapInCtx) ? (mapInCtx || {}) : (kisiMapFallback || {});

  // YETKİ TANIMLAMALARI
  const canAylikIsg = effectiveMap["aylik-isg"] === true;
  const canPatron = effectiveMap["patron"] === true;
  const canHakedisTanim = effectiveMap["hakedis-tanimlari"] === true;
  const canHakedisHesap = effectiveMap["hakedis-hesaplama"] === true;
  
  const isOwner = role?.toLocaleLowerCase("tr-TR") === "oluşturucu";

  // Sayfa bazlı nihai izinler
  const canSeeTanimlari = canHakedisTanim || isOwner;
  const canSeeHesaplama = canHakedisHesap || isOwner;
  const hasAny = canAylikIsg || canPatron || canSeeTanimlari || canSeeHesaplama;

  const getDefaultPath = () => {
    if (canAylikIsg) return "aylik-isg";
    if (canSeeHesaplama) return "hakedis-hesaplama";
    if (canSeeTanimlari) return "hakedis-tanimlari";
    if (canPatron) return "patron";
    return "aylik-isg";
  };

  return (
    <>
      <Navbar />
      <div style={{ overflow: "visible" }}> {/* Filtre kutusunun kesilmemesi için */}
        {!hasAny ? (
          <div style={{ padding: 16 }}>
            <div style={{ padding: 12, border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
              Bu modül için yetkiniz bulunmuyor.
            </div>
          </div>
        ) : (
          <Routes>
            <Route path="/" element={<Navigate to={getDefaultPath()} replace />} />
            {canAylikIsg && <Route path="aylik-isg" element={<AylikIsg />} />}
            {canAylikIsg && <Route path="firestore-console" element={<FirestoreSqlConsole />} />}
            {canPatron && <Route path="patron" element={<PatronRutin />} />}
            
            {/* Yetkiye özel Route'lar */}
            {canSeeTanimlari && <Route path="hakedis-tanimlari" element={<HakedisTanimlari />} />}
            {canSeeHesaplama && <Route path="hakedis-hesaplama" element={<HakedisHesaplama />} />}

            <Route path="*" element={<Navigate to={getDefaultPath()} replace />} />
          </Routes>
        )}
      </div>
    </>
  );
}